import React, { useEffect, useState, useRef, useContext } from 'react';
import { LanguageContext } from '../../App';
import { PlusIcon, UserPlusIcon, BellIcon, MessageSquareIcon, PhoneIcon, UserIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChevronDownIcon, LayoutDashboardIcon, TruckIcon, PackageIcon, XIcon } from 'lucide-react';
import { LiveMap } from './LiveMap';
import { QuickActions } from './QuickActions';
import { DriverList } from './DriverList';
import { StatisticsSection } from './StatisticsSection';
import { CountUp } from '../ui/CountUp';
import { motion, AnimatePresence } from 'framer-motion';
export const LiveDashboard: React.FC = () => {
  const {
    language
  } = useContext(LanguageContext);
  const [selectedDriver, setSelectedDriver] = useState<any>(null);
  const [isCardCollapsed, setIsCardCollapsed] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showOperationsPanel, setShowOperationsPanel] = useState(false);
  const mapWrapperRef = useRef<HTMLDivElement>(null);
  const toggleOperationsPanel = () => {
    setShowOperationsPanel(!showOperationsPanel);
    setIsCardCollapsed(false); // Always expand when showing
  };
  // Handle fullscreen change events
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isDocFullscreen = !!document.fullscreenElement || !!(document as any).webkitFullscreenElement || !!(document as any).mozFullScreenElement || !!(document as any).msFullscreenElement;
      setIsFullscreen(isDocFullscreen);
      // If we have the map wrapper, ensure its CSS is updated
      if (mapWrapperRef.current) {
        if (isDocFullscreen) {
          mapWrapperRef.current.classList.add('fullscreen-active');
        } else {
          mapWrapperRef.current.classList.remove('fullscreen-active');
        }
      }
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);
  return <div className="space-y-6" data-id="element-62">
      {/* Map container with unified wrapper for fullscreen */}
      <div className="relative w-full mb-6" data-id="element-63">
        {/* Unified fullscreen wrapper containing map and all overlays */}
        <div id="dashboard-map-wrapper" ref={mapWrapperRef} className={`relative w-full h-[600px] rounded-lg overflow-hidden border border-gray-200 shadow-sm ${isFullscreen ? 'fullscreen-active' : ''}`} style={{
        zIndex: isFullscreen ? 9999 : 'auto'
      }} data-id="element-64">
          {/* Full-width map container with absolute positioning */}
          <div className="absolute inset-0 w-full h-full z-10" data-id="element-65">
            <LiveMap selectedDriver={selectedDriver} onDriverSelect={setSelectedDriver} mapWrapperRef={mapWrapperRef} onToggleOperations={toggleOperationsPanel} showOperations={showOperationsPanel} isCardCollapsed={isCardCollapsed} setIsCardCollapsed={setIsCardCollapsed} data-id="element-66" />
          </div>
          {/* Add improved fullscreen CSS styles */}
          <style jsx data-id="element-67">{`
            .fullscreen-active {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              right: 0 !important;
              bottom: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              z-index: 9999 !important;
              margin: 0 !important;
              padding: 0 !important;
              border: none !important;
              border-radius: 0 !important;
              background-color: white !important;
            }
            .fullscreen-active > div {
              height: 100vh !important;
              width: 100vw !important;
            }
            /* Ensure Leaflet container takes full height in fullscreen */
            .fullscreen-active :global(.leaflet-container) {
              height: 100vh !important;
              width: 100vw !important;
            }
          `}</style>
        </div>
      </div>
      {/* Statistics Section */}
      <StatisticsSection data-id="element-68" />
    </div>;
};